import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { MarketplaceProductsPageConfig } from '@front-platform/content-builder';
import { marketplaceProductsPageResolveConfig } from '@front-platform/content-builder';
import { Component, OnDestroy, OnInit, input } from '@angular/core';
import {
  CartOverviewModalComponent,
  CartOverviewModalConfig,
} from '../../modals/cart-overview-modal/cart-overview-modal.component';
import { ModalsService } from '@core/services/modals/modals.service';
import { ActivatedRoute } from '@angular/router';
import { NavigationHistoryService } from '@core/services/navigation-history/navigation-history.service';
export interface MarketplaceProductsPageRuntimeConfig {
  'body'?: any;
}

export type MarketplaceProductsPageConfigInput = Partial<
  Omit<MarketplaceProductsPageConfig, keyof MarketplaceProductsPageRuntimeConfig> &
    MarketplaceProductsPageRuntimeConfig
>;
export type MarketplaceProductsPageResolvedConfig = Omit<
  MarketplaceProductsPageConfig,
  keyof MarketplaceProductsPageRuntimeConfig
> &
  Partial<MarketplaceProductsPageRuntimeConfig>;
export interface MarketplaceProductsPageContract extends ConfigComponentContract<
  MarketplaceProductsPageConfigInput,
  MarketplaceProductsPageResolvedConfig
> {}

@Component({
  selector: 'app-marketplace-products-page',
  templateUrl: './marketplace-products-page.component.html',
  standalone: false,
})
export class MarketplaceProductsPageComponent
  implements OnInit, OnDestroy, MarketplaceProductsPageContract
{
  readonly config = input<MarketplaceProductsPageConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    MarketplaceProductsPageConfig,
    MarketplaceProductsPageRuntimeConfig
  >(marketplaceProductsPageResolveConfig, () => ({ config: this.config() }));
  get body(): any {
    return this.resolvedConfig()['body'] as unknown as any;
  }

  constructor(
    private readonly modalsService: ModalsService<CartOverviewModalConfig>,
    private readonly activatedRoute: ActivatedRoute,
    private readonly navigationHistoryService: NavigationHistoryService,
  ) {}

  ngOnInit(): void {
    this.navigationHistoryService.pushStateFromActivatedRouteSnapshot(
      'marketplace-product-list',
      this.activatedRoute.snapshot,
    );
    this.modalsService.open(CartOverviewModalComponent.handle);
  }

  ngOnDestroy(): void {
    this.modalsService.close(CartOverviewModalComponent.handle);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(MarketplaceProductsPageComponent, {
  'keyAliases': {},
});
